import React, { Fragment, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { action, isObservableProp, observe } from 'mobx';
import { useRerender } from 'cd-eft/hooks/useRerender';
import './TableView.scss';

const defaultAnyFormatter = (v: any): any => {
  return v;
};

const defaultAnyParser = (v: any): any => {
  return v;
};

const defaultValidator = (v: any, props: IFieldProps): boolean => {
  return true;
};

const defaultSelectValidator = (v: any): boolean => {
  return true;
  // return (
  //   props.inputType === 'select' && undefined !== props.selectOptions && props.selectOptions.some((i) => i.value === v)
  // );
};

const defaultStringFormatter = (v: any): string => {
  if (v === undefined || v === null) return '';
  return v;
};

interface ISelectInputOption {
  name: string;
  value: any;
}

interface ILinkedValueOptions {
  linkedValue: string;
  linkedOptions: ISelectInputOption[];
}

interface IFieldProps {
  caption: string;
  property: string;
  // propertyType?: 'string' | 'number';
  formatter?: (value: any) => any;
  canEdit?: boolean;
  inputType?: 'text' | 'select' | 'linked-select';
  selectOptions?: ISelectInputOption[];
  linkedProperty?: string;
  linkedValueOptionsSet?: ILinkedValueOptions[];
  onChange?: (e: any) => void;
  // onBlur?: (e: any) => void;
  validator?: (value: any) => boolean;
  validationCallback?: () => any;
  parser?: (value: any) => any;
  nestedOptions?: boolean;
}

interface ISelectedRowsChangedEvent {
  // added: any[];
  // removed: any[];
  readonly selectedRows: any[];
}

interface ITableViewProps {
  fields: IFieldProps[];
  rowsSource: any[];
  onMouseEnterRow?: (e: any) => void;
  onMouseLeaveRow?: (e: any) => void;
  selectionMode?: 'none' | 'single' | 'multiple';
  selectedRows?: any[];
  onSelectedRowsChanged?: (e: ISelectedRowsChangedEvent) => void;
}

export const TableView = observer(function (props: ITableViewProps) {
  const rerender = useRerender();

  const selectedRowsRef = useRef(props.selectedRows);

  const selectedRows = selectedRowsRef.current!;

  const selectionMode = props.selectionMode || 'none';
  const isSelected = selectedRows.length === props.rowsSource.length;
  return (
    <Fragment>
      <table className="table-sm table epad-tableview">
        <thead className="table-head">
          <tr>
            {(props.selectionMode === 'single' || props.selectionMode === 'multiple') && (
              <th className="table-headers">
                {props.selectionMode === 'multiple' && (
                  <UswdsCheckbox
                    checked={isSelected}
                    onChange={(e) => {
                      // if (e.target.checked)
                      // console.log(e.target.checked);
                      if (e.target.checked) {
                        selectedRows.splice(0, selectedRows.length);

                        selectedRows.push(...props.rowsSource);

                        // if (!props.selectedRows.includes(props.rowSource)) {
                        //   props.selectedRows.push(props.rowSource);
                        // }
                      } else {
                        // const index = props.selectedRows.indexOf(props.rowSource);
                        // props.selectedRows.splice(index, 1);

                        selectedRows.splice(0, selectedRows.length);
                      }
                      // rerender();
                      if (props.onSelectedRowsChanged) {
                        props.onSelectedRowsChanged({ selectedRows: selectedRows });
                      }
                    }}
                  />
                )}
              </th>
            )}
            {props.fields.map((field, index, array) => {
              return <th className="table-headers">{field.caption}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {props.rowsSource.map((row, index, array) => {
            return (
              <RowView
                rowSource={row}
                fields={props.fields}
                selectionMode={selectionMode}
                selectedRows={selectedRows}
                onMouseEnterRow={props.onMouseEnterRow}
                onMouseLeaveRow={props.onMouseLeaveRow}
                onSelectedRowsChanged={props.onSelectedRowsChanged}
                index={index}
              />
            );
          })}
        </tbody>
      </table>
    </Fragment>
  );
});

interface IRowViewProps {
  rowSource: any;
  fields: IFieldProps[];
  onMouseEnterRow?: (e: any) => void;
  onMouseLeaveRow?: (e: any) => void;
  selectionMode: 'none' | 'single' | 'multiple';
  selectedRows: any[];
  onSelectedRowsChanged?: (e: ISelectedRowsChangedEvent) => void;
  index?: number;
}

const RowView = observer(function (props: IRowViewProps) {
  const rerender = useRerender();

  const isSelected = props.selectedRows.includes(props.rowSource);

  return (
    <tr
      id={'lulc-table-row-' + props.rowSource['OBJECTID']}
      onMouseEnter={(event) => {
        if (props.onMouseEnterRow) {
          props.onMouseEnterRow({ props: props, event: event });
        }
      }}
      onMouseLeave={(event) => {
        if (props.onMouseLeaveRow) {
          props.onMouseLeaveRow({ props: props, event: event });
        }
      }}
    >
      {(props.selectionMode === 'single' || props.selectionMode === 'multiple') && (
        <td>
          <UswdsCheckbox
            checked={isSelected}
            onChange={action((e) => {
              // if (e.target.checked)

              if (e.target.checked) {
                if (!props.selectedRows.includes(props.rowSource)) {
                  props.selectedRows.push(props.rowSource);
                }
              } else {
                const index = props.selectedRows.indexOf(props.rowSource);
                props.selectedRows.splice(index, 1);
              }
              // rerender();
              if (props.onSelectedRowsChanged) {
                props.onSelectedRowsChanged({ selectedRows: props.selectedRows });
              }
            })}
          />
        </td>
      )}
      {props.fields.map((field, index, array) => {
        return <CellView rowSource={props.rowSource} field={field} index={props.index} />;
        // return <CellView rowSource={props.rowSource} field={field} onInvalidated={rerender} />;
      })}
    </tr>
  );
});

interface ICellViewProps {
  rowSource: any;
  field: IFieldProps;
  index?: number;
  // onInvalidated?: () => void;
}

const CellView = observer(function (props: ICellViewProps) {
  if (props.field.canEdit) {
    switch (props.field.inputType) {
      case 'linked-select':
        return <LinkedSelectInputCell {...props} />;
      case 'select':
        return <SelectInputCell {...props} />;
      case 'text':
        return <TextInputCell {...props} />;
      default:
        return <TextInputCell {...props} />;
    }
  } else {
    return <ReadonlyTextCell {...props} />;
  }
});

const ReadonlyTextCell = observer(function (props: ICellViewProps) {
  const formatter = props.field.formatter || defaultStringFormatter;
  const value = formatter(props.rowSource[props.field.property]);
  return <td>{value}</td>;
});

const TextInputCell = observer(function (props: ICellViewProps) {
  const rerender = useRerender();
  const formatter = props.field.formatter || defaultStringFormatter;
  const parser = props.field.parser || defaultAnyParser;
  const onChange =
    props.field.onChange ||
    ((e) => {
      props.rowSource[props.field.property] = parser(e.target.value);
      if (!isObservableProp(props.rowSource, props.field.property)) {
        rerender(); //ensures rerender when rowSource is not observable
      }
      // if (props.onInvalidated) props.onInvalidated();
    });
  const value = formatter(props.rowSource[props.field.property]);
  return (
    <td>
      <input type="text" value={value} onChange={onChange} />
    </td>
  );
});

const SelectInputCell = observer(function (props: ICellViewProps) {
  const rerender = useRerender();
  const formatter = props.field.formatter || defaultStringFormatter;
  const parser = props.field.parser || defaultAnyParser;
  const value = formatter(props.rowSource[props.field.property]);
  const validator = props.field.validator || defaultSelectValidator;
  let isValid = validator(value);
  const onChange =
    props.field.onChange ||
    ((e) => {
      // isValid = validator(e.target.value);

      // if (isValid) {
      props.rowSource[props.field.property] = parser(e.target.value);
      // }
      if (!isObservableProp(props.rowSource, props.field.property)) {
        rerender(); //ensures rerender when rowSource is not observable
      }
      // if (props.onInvalidated) props.onInvalidated();
    });
  // const value = formatter(props.rowSource[props.field.property]);
  if (props.field.validationCallback) {
    props.field.validationCallback();
  }

  return (
    <td>
      <UswdsSelect
        valid={isValid}
        value={value}
        options={props.field.selectOptions}
        onChange={onChange}
        nestedOptions={props.field.nestedOptions}
        index={props.index}
      />
    </td>
  );
});

const LinkedSelectInputCell = observer(function (props: ICellViewProps) {
  const rerender = useRerender();
  const formatter = props.field.formatter || defaultStringFormatter;
  const parser = props.field.parser || defaultAnyParser;
  const value = formatter(props.rowSource[props.field.property]);
  const validator = props.field.validator || defaultSelectValidator;
  let isValid = validator(value);
  const onChange =
    props.field.onChange ||
    ((e) => {
      // isValid = validator(e.target.value);

      // if (isValid) {
      props.rowSource[props.field.property] = parser(e.target.value);
      // }
      if (!isObservableProp(props.rowSource, props.field.property)) {
        rerender(); //ensures rerender when rowSource is not observable
      }
    });

  if (props.field.validationCallback) {
    props.field.validationCallback();
  }

  const linkedValue = props.rowSource[props.field.linkedProperty!];
  const linkedOptions = props.field.linkedValueOptionsSet!.find((item) => {
    return item.linkedValue === linkedValue;
  })?.linkedOptions;

  //TODO: what to do about this observer handle? should get cleaned up or bad things might happen! Maybe useEffect pattern would be a good strategy?
  const stopObserving = observe(props.rowSource, props.field.linkedProperty, (e) => {
    //any time linkedProperty changes, reset target property to
    props.rowSource[props.field.property] = null;
  });

  // This use effect should handle preselecting a a Land Use Condition if there is only one associated option
  useEffect(() => {
    if (props.rowSource[props.field.property] === null) {
      if (linkedOptions && linkedOptions.length === 1) {
        const mockEvent = { target: { value: linkedOptions[0].value[0] } }
        onChange(mockEvent)
        rerender();
      }
      else {
        props.rowSource[props.field.property] = null;
      }
    }
  }, [props.rowSource[props.field.linkedProperty!]])

  return (
    <td>
      <UswdsSelect
        valid={isValid}
        value={value}
        options={linkedOptions}
        onChange={onChange}
        nestedOptions={props.field.nestedOptions}
        index={props.index}
      />
    </td>
  );
});

interface IUswdsCheckboxProps {
  checked?: boolean;
  label?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

let __USWDS_CHECKBOX_COUNTER = 0;
const UswdsCheckbox = observer(function (props: IUswdsCheckboxProps) {
  __USWDS_CHECKBOX_COUNTER++;
  const autoId = 'uswds-checkbox-' + __USWDS_CHECKBOX_COUNTER;

  return (
    <Fragment>
      <input
        id={autoId} // id is req'd for UswdsCheckbox to work correctly
        className="usa-checkbox__input"
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
      />
      <label htmlFor={autoId} className="usa-checkbox__label">
        {props.label}
      </label>
    </Fragment>
  );
});

interface IUswdsSelect {
  id?: string;
  name?: string;
  label?: string;
  initValue?: any;
  valid?: boolean;
  required?: boolean;
  value?: string;
  onChange?: (event: {}) => void;
  options?: IUswdsSelectOption[];
  errorMsg?: string;
  nestedOptions?: boolean;
  index?: number;
}
interface IUswdsSelectOption {
  name: string;
  value: string;
}

const UswdsSelect = observer((props: IUswdsSelect) => {
  return (
    <Fragment>
      {/* {props.label !== undefined && (
        <label className="usa-label" htmlFor={props.idAndName}>
          {props.label}
        </label>
      )} */}
      {/* <div className="usa-combo-box" data-default-value={props.initValue}> */}
      <select
        // data-testid="the-ComboBox"
        className={props.valid ? 'usa-select' : 'usa-select usa-input--error'}
        // name={props.idAndName}
        // id={props.idAndName}
        aria-describedby={props.id + '--err'}
        aria-invalid={!props.valid}
        aria-required={props.required}
        value={props.value}
        onChange={props.onChange}
      >
        <option value=""> - select - </option>

        {props.options !== undefined &&
          props.options.map((el, i) => (
            <option value={el.value} key={el.value + i}>
              {el.name}
            </option>
          ))}
      </select>

      {/* </div> */}
      {/* <span className="usa-error-message" id={props.idAndName + '--err'} role="alert">
        {props.errorMsg}
      </span> */}
    </Fragment>
  );
});

// export const TableView = observer(TableViewComponent);

// interface ISelectedChangeActionEventData {
//   selected: boolean;
// }
// type SelectedChangeAction = (e: ISelectedChangeActionEventData) => void;

// interface ILanduseRowViewComponentProps {
//   feature: Graphic;
//   landUseOptions: any;
//   conditionOptions: any;
//   graphicsLayerView: GraphicsLayerView;
//   // selected: boolean;
//   onSelectedChange?: SelectedChangeAction;
//   onMouseEnter?: () => void;
//   onMouseLeave?: () => void;
// }

// interface IFeatureExt {
//   _IFeatureExt_checked: boolean;
//   _IFeatureExt_checkHighlight?: __esri.Handle;
//   _IFeatureExt_overHighlight?: __esri.Handle;
// }

// interface ILanduseTableViewComponentProps {
//   graphicsLayerView: GraphicsLayerView;
//   selectedGraphics?: Graphic[];
//   // featureSet: FeatureSet;
//   landUseOptions: any;
//   conditionOptions: any;
// }

// function LanduseTableViewComponent(props: ILanduseTableViewComponentProps) {
//   const graphicsLayer = props.graphicsLayerView.layer as GraphicsLayer;
//   return (
//     <table>
//       <thead>
//         <tr>
//           <th>
//             {/* <input type="checkbox" /> */}
//             <UswdsCheckbox />
//           </th>
//           <th>#</th>
//           <th>Land Use</th>
//           <th>Condition</th>
//           <th>Acres</th>
//         </tr>
//       </thead>
//       <tbody>
//         {graphicsLayer.graphics.map((value, index) => {
//           return (
//             <LanduseRowViewComponent
//               key={index}
//               feature={value}
//               landUseOptions={props.landUseOptions}
//               conditionOptions={props.conditionOptions}
//               graphicsLayerView={props.graphicsLayerView}
//             />
//           );
//         })}
//       </tbody>
//     </table>
//   );
// }

// function LanduseRowViewComponent(props: ILanduseRowViewComponentProps) {
//   const [checked, setChecked] = useState<boolean>(false);
//   // const [highlightHandle1, setHighlightHandle1] = useState<__esri.Handle | undefined>(undefined);
//   const landUseOptions = props.landUseOptions.map((item, index, array) => {
//     return { name: item, value: item };
//   });
//   const conditionOptions = props.conditionOptions.map((item, index, array) => {
//     return { name: item, value: item };
//   });
//   const feature = props.feature;
//   const featureExt = (feature as unknown) as IFeatureExt;
//   return (
//     <tr
//       onMouseEnter={() => {
//         if (featureExt._IFeatureExt_overHighlight) {
//           featureExt._IFeatureExt_overHighlight.remove();
//           featureExt._IFeatureExt_overHighlight = undefined;
//         }
//         //create the highlight handle and stuff into the feature instance for later retrieval
//         featureExt._IFeatureExt_overHighlight = props.graphicsLayerView.highlight(props.feature);
//       }}
//       onMouseLeave={() => {
//         if (featureExt._IFeatureExt_overHighlight) {
//           featureExt._IFeatureExt_overHighlight.remove();
//           featureExt._IFeatureExt_overHighlight = undefined;
//         }
//       }}
//     >
//       <td>
//         {/* <input
//           // className="usa-checkbox__input"
//           // data-behavior="select-table-row"
//           // id={'select' + i}
//           // data-testid={'select' + i}
//           type="checkbox"
//           // name={item.attributes.OBJECTID}
//           // value="select"
//           // checked={vm.checkedLandUse.includes(item.attributes.OBJECTID)}
//           // onChange={vm.onLandUseRowCheckChanged}
//           onChange={() => {
//             console.log('onChangeA');
//           }}
//         /> */}
//         {/* <label className="usa-checkbox__label" htmlFor={'select' + i}></label> */}
//         <UswdsCheckbox
//           checked={checked}
//           onChange={(e) => {
//             const checked = e.target.checked; //override scope
//             setChecked(checked); // update the value for rerender

//             // remove existing highlight
//             if (featureExt._IFeatureExt_checkHighlight) {
//               featureExt._IFeatureExt_checkHighlight.remove();
//               featureExt._IFeatureExt_checkHighlight = undefined;
//             }
//             if (checked) {
//               //create the highlight handle and stuff into the feature instance for later retrieval
//               featureExt._IFeatureExt_checkHighlight = props.graphicsLayerView.highlight(props.feature);
//             }

//             // console.log('onChangeB', featureExt);
//           }}
//         />
//       </td>
//       <td>{props.feature.attributes.OBJECTID}</td>
//       <td>
//         {/* <select
//           // className={'usa-select' + vm.errorClass('LANDUSE', item.attributes.LANDUSE)}
//           // want to refactor this to be dynamic
//           // name="LANDUSE"
//           // id={'land-use-options' + idx}
//           // onChange={(event) => {
//           //   vm.handleInputChange(event, idx, vm.landUseTable);
//           // }}
//           // value={item.attributes.LANDUSE || ''}
//           value={props.feature.attributes.LANDUSE || ''}
//         >
//           <option value=""> - select - </option>
//           {props.landUseOptions.map((value, index) => (
//             <option value={value} key={index}>
//               {value}
//             </option>
//           ))}
//         </select> */}
//         <ComboBox options={landUseOptions} />
//       </td>
//       <td>
//         {/* <select
//           // className={'usa-select' + vm.errorClass('CONDITION', item.attributes.CONDITION)}
//           // want to refactor this to be dynamic
//           // name="CONDITION"
//           // id={'land-condition-options' + idx}
//           // onChange={(event) => {
//           //   vm.handleInputChange(event, idx, vm.landUseTable);
//           // }}
//           // value={item.attributes.CONDITION || ''}
//           value={props.feature.attributes.CONDITION || ''}
//         >
//           <option value=""> - select - </option>
//           {props.conditionOptions.map((value, index) => (
//             <option value={value} key={index}>
//               {value}
//             </option>
//           ))}
//         </select> */}
//         <ComboBox options={conditionOptions} />
//       </td>
//       <td>{props.feature.attributes.Acres?.toFixed(2)}</td>
//     </tr>
//   );
// }

// export const LanduseTableView = observer(LanduseTableViewComponent);
